import { Reducer } from 'redux';
import { SubmissionActionTypes } from '../constants/actionTypes';
import {
  IStoreTransactionSubmissionAction,
  ISubmissionActions,
  ISubmissionCancelActionError,
  ISubmissionCreateAction,
  ISubmissionCreateActionError,
  ISubmissionRefreshAction,
  ISubmissionsGetAction,
  ISubmissionsGetActionError,
  ISubmissionState,
} from '../types/Submission';

// Define the initial state
const initialState: ISubmissionState = {
  refreshSubmissionsState: true,
};

const submissionReducer: Reducer<ISubmissionState, ISubmissionActions> = (
  state = initialState,
  action: ISubmissionActions,
) => {
  switch (action.type) {
    case SubmissionActionTypes.CREATE_NEW_LOAN_SUBMISSION:
      return {
        ...state,
        newSubmission: (action as ISubmissionCreateAction).submissionData,
        submissionCreateApiErrors: undefined,
      };
    case SubmissionActionTypes.GET_SUBMISSIONS:
      return {
        ...state,
        submissionsData: (action as ISubmissionsGetAction).submissionsData,
        submissionsGetApiErrors: undefined,
      };
    case SubmissionActionTypes.CANCEL_SUBMISSION:
      return {
        ...state,
        submissionCancelApiErrors: undefined,
      };
    case SubmissionActionTypes.ERROR_CREATE_NEW_LOAN_SUBMISSION:
      return {
        ...state,
        newSubmission: undefined,
        submissionCreateApiErrors: (action as ISubmissionCreateActionError).submissionApiErrors,
      };
    case SubmissionActionTypes.ERROR_GET_SUBMISSIONS:
      return {
        ...state,
        submissionsData: undefined,
        submissionsGetApiErrors: (action as ISubmissionsGetActionError).submissionApiErrors,
      };
    case SubmissionActionTypes.ERROR_CANCEL_SUBMISSION:
      return {
        ...state,
        submissionCancelApiErrors: (action as ISubmissionCancelActionError).submissionApiErrors,
      };
    case SubmissionActionTypes.REFRESH_SUBMISSIONS:
      return {
        ...state,
        refreshSubmissionsState: (action as ISubmissionRefreshAction).refreshSubmissionsState,
      };
    case SubmissionActionTypes.STORE_TRANSACTIONS: {
      const { submissionsV2Data = {} } = state;
      return {
        ...state,
        submissionsV2Data: {
          ...submissionsV2Data,
          ...(action as IStoreTransactionSubmissionAction).data,
        },
      };
    }
    case SubmissionActionTypes.CLEAR_SUBMISSIONS_V2_PAYLOAD: {
      return {
        ...state,
        submissionsV2Data: undefined,
        submissionCreateApiErrors: undefined,
      };
    }
    default:
      return state;
  }
};

export default submissionReducer;
